import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { SwitchApiClient } from '../../api-clients';
const {
  Provider,
  context,
  ...client
} = SwitchApiClient;
export const SwitchExtension = createModuleExtension({
  extensionName: 'switchExtension',
  Provider,
  SDK: {
    switchApiClient: client,
    switchContext: context
  }
});
//# sourceMappingURL=switch.extension.js.map